import SelectorComponent from '@components/selector/selector.component'
import localForageHelper from '@helpers/localforage.helper'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './toggle-theme.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  labelPosition?: 'left' | 'right' | 'none'
  fontSize?: string
  marginAutoToggle?: boolean
}

export default ({ labelPosition = 'left', className = '', fontSize = '1rem', marginAutoToggle = false, ...rest }: Props) => {
  const [checked, setChecked] = useState(window.matchMedia('(prefers-color-scheme:dark)').matches)
  const { t } = useTranslation('toggleThemeComponent')

  const handleChange = useCallback(
    async (thisCheck: boolean) => {
      document.body.classList.value = `scrollbar ${thisCheck ? 'dark' : 'light'}`
      await localForageHelper.setItem('theme', thisCheck ? 'dark' : 'light')
      setChecked(thisCheck)
    },
    [setChecked]
  )

  useEffect(() => {
    localForageHelper.getItem('theme').then((theme) => {
      if (theme) {
        handleChange(theme === 'dark')
      }
    })
  }, [handleChange])

  return (
    <SelectorComponent
      className={'theme-selector' + className + ` ${marginAutoToggle ? 'align-op' : ''}`}
      errorSpan={false}
      checked={checked}
      onChange={(c: boolean) => handleChange(c)}
      toggle
      name="select-theme"
      id="select-theme"
      labelFontSize={fontSize}
      rightLabel={labelPosition === 'right' ? t('label') : null}
      leftLabel={labelPosition === 'left' ? t('label') : null}
      {...rest}
    />
  )
}
